<template>
  <!-- <h2>楓之谷R儲值流程</h2> -->
  <div class="infoCenter enCss">
    <h3>Game Sign in/Register</h3>
    <p>
      Currently, the game supports 5 login/register methods, including
      quick-sign-in, Facebook Login, phone number Login, Google account Login,
      and email Login. <br />For quick-register, select [Register], manually
      enter a custom account and custom password, re-enter the password, and
      click the [Register] button below to complete account registration and
      enter the game.
    </p>
    <img src="./../../../assets/info/en/1.png" />

    <h3>Top Up Center</h3>
    <p>
      After entering the game on the PC site, upgrade the character level to
      Lv.21 to unlock the Top Up function, select the [Expand] button on the
      upper left, then select [Discount] to enter the pack page
    </p>
    <img src="./../../../assets/info/en/2.png" />
    <p>
      1. After clicking on the gift pack you want to buy, you will jump to the
      [Top Up Center] and enter the process of purchasing packs
    </p>
    <p>2. Next, you need to confirm the following options</p>
    <p>Select the language in the upper right corner</p>
    <p>Select the server that needs to top up</p>
    <p>Select the character</p>
    <p>Select the country or region for the payment</p>
    <p>Select the corresponding payment method</p>
    <img src="./../../../assets/info/en/3.png" />

    <p>
      3. After selecting the Top up method, manually select the corresponding
      number of the colored diamond pack, repeatedly confirm the character
      information in the pop-up window, and click [Confirm] after confirmation.
      *(After successfully topping up, you need to claim the pack in the game
      before 5:00 am the next day, otherwise the item may be lost.)
    </p>
    <p>PayerMax-PayNow</p>
    <p>
      Click the PayerMax-PayNow payment channel and select your favorite pack
    </p>
    <img src="./../../../assets/info/en/4.png" />

    <p>
      4. After confirming the information, jump to the corresponding payment
      channel, and complete the payment according to the instruction
    </p>
    <img src="./../../../assets/info/en/5.png" />
    <p>TikiPay-Union pay</p>
    <p>
      Click the TikiPay-Union pay payment channel and select your favorite pack
    </p>

    <img src="./../../../assets/info/en/6.png" />

    <p>
      After confirming the information, jump to the payment interface, correctly
      fill in the email address, mobile phone number, and name, and click [Pay
      Now]
    </p>
    <img src="./../../../assets/info/en/7.png" />

    <h3>More Page Functions</h3>
    <p>1.Download</p>
    <p>
      Clicks [Install], the game page will open in a separate window, and it can
      be fixed to the taskbar on the desktop. You can also find the startup icon
      on the [Start] interface
    </p>
    <img src="./../../../assets/info/en/8.png" />
    <p>2.Official website</p>
    <p>
      Click [Website] to jump to the official website page for the latest
      information!
    </p>
    <img src="./../../../assets/info/en/9.png" />
    <img src="./../../../assets/info/en/10.png" />
    <p>3.Collect</p>
    <p>
      Click [Collect], the page will be added to the favorites of the browser,
      you can directly open the game in the favorites of the browser
    </p>
    <img src="./../../../assets/info/en/11.png" />
    <p>4.Customer Service</p>
    <p>
      Click the [Customer Service] button to enter the customer service center
      where you can view the quick FAQ questions to find solutions. If the quick
      FAQ questions do not answer your questions, you can fill in the question
      form according to the actual questions!
    </p>
    <img src="./../../../assets/info/en/12.png" />
  </div>
</template>

<script>
export default {
  name: "RastarEn",
  data() {
    return {};
  },
  created() {},
};
</script>

<style lang="scss" src="./style.scss" scoped></style>